





























































































































































































































































































































/* eslint-disable  @typescript-eslint/no-explicit-any */

import store from '../store'
import AnimatedNumber from 'animated-number-vue'
import dayjs from 'dayjs'
import { mapGetters, mapState } from 'vuex'
import { Print } from '@/mixins/mixins'
import Confirm from './Confirm.vue'

export default {
  props: {
    type: Number,
    title: String,
    summary: String,
    ibreeds: Array,
    ispecifyAllowance: Number,
    ipaddock: Object
  },

  mixins: [Print],

  data: () => {
    return {
      activeTab: 0,
      pdTooltip: false,
      saveform: {
        show: false,
        name: '',
        nameRules: [(v: string) => !!v || 'Name is required'],
        paddock: '',
        paddockRules: [(v: string) => !!v || 'Paddock is required']
      },
      display: 'cards',
      headers: [
        {
          text: 'Stock class',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Pasture allowance (kg DM/head/day, 10MJ ME/kg DM)',
          align: 'center',
          sortable: true,
          value: 'allowance'
        },
        {
          text: 'Stocking rate',
          align: 'center',
          sortable: true,
          value: 'stockingRate'
        }
      ],
      formattedCalculations: [],
      breeds: [],
      specifyAllowance: 0,
      paddock: {
        size: 0,
        growthRate: 0,
        pastureStart: 0,
        pastureEnd: 0,
        daysGrazing: 0
      },
      defaultProps: {
        paddock: {
          size: 0,
          growthRate: 0,
          pastureStart: 0,
          pastureEnd: 0,
          daysGrazing: 0
        }
      }
    }
  },

  filters: {
    fixed (value: any, decimals?: any) {
      if (typeof value === 'number' && value !== null && value % 1 !== 0 && value !== undefined && !(isNaN(value))) {
        return decimals !== undefined ? value.toFixed(decimals) : value.toFixed(1)
      }
      return value
    }
  },

  computed: {
    ...mapGetters(['getCalculations']),
    ...mapState(['calculations']),
    growth: function (this: any): number {
      return (
        parseFloat(this.paddock.pastureStart) +
        parseFloat(this.paddock.growthRate) *
        parseFloat(this.paddock.daysGrazing) -
        parseFloat(this.paddock.pastureEnd)
      )
    }
  },

  methods: {
    dayjs,
    // Load saved calculation
    load (this: any, calculation: any) {
      this.activeTab = 0
      this.paddock = {
        ...calculation.data
      }
      this.specifyAllowance = calculation.specifyAllowance
    },

    // Remove saved calculation
    async remove (this: any, calculation: any) {
      if (await this.$refs.confirm.open(
        'Delete Scenario',
        'Are you sure you want to delete this scenario: ' + calculation.name,
        {
          color: 'red',
          cta: 'Delete'
        }
      )) {
        this.$store.dispatch('removeCalculation', calculation)
        this.refreshCalculations()
      }
      return 0
    },

    // Save current calculation
    save (this: any) {
      if (this.$refs.saveForm.validate()) {
        this.$store.dispatch('addCalculation', {
          type: this.$props.type,
          calculationDate: new Date(),
          data: {
            ...this.paddock
          },
          name: this.saveform.name,
          paddock: this.saveform.paddock,
          specifyAllowance: this.specifyAllowance
        })
        this.saveform.name = ''
        this.saveform.paddock = ''
        this.saveform.show = false
        this.refreshCalculations()
      } else {
        // console.log('Form is invalid')
      }
    },

    // Calculate the stocking rate
    CalculateStockNumbers: function (this: any, allowance: number): number {
      return parseFloat((
        (
          this.paddock.size *
          (this.growth / allowance / this.paddock.daysGrazing) * 10
        ) / 10
      ).toFixed(1))
    },

    // Convert float to int
    formatNumber (this: any, value: number): string {
      return this.$options.filters.fixed(value);
    },

    // Set all paddock description values to 0
    ClearPaddockDesc: function (this: any) {
      this.$set(this, 'paddock', {
        size: 0,
        growthRate: 0,
        pastureStart: 0,
        pastureEnd: 0,
        daysGrazing: 0
      })
      this.specifyAllowance = this.defaultProps.specifyAllowance
    },

    // Reset all paddock description values to defaults
    ResetPaddockDesc: function (this: any) {
      this.$set(this, 'paddock', {
        size: this.defaultProps.paddock.size,
        growthRate: this.defaultProps.paddock.growthRate,
        pastureStart: this.defaultProps.paddock.pastureStart,
        pastureEnd: this.defaultProps.paddock.pastureEnd,
        daysGrazing: this.defaultProps.paddock.daysGrazing
      })
      this.specifyAllowance = this.defaultProps.specifyAllowance
    },

    // Load all saved calculations into previous results tab
    loadCalculationsFromStore: function (this: any) {
      type MonthCalculations = { month: string; calculations: object[] } | null
      const months: MonthCalculations[] = []
      let calculations = this.getCalculations(this.$props.type)
      if (calculations) {
        calculations = calculations.sort(function (a: any, b: any) {
          a = a.calculationDate
          b = b.calculationDate
          return a > b ? -1 : a < b ? 1 : 0
        })
        const MonthMap: any = {
          0: 'January',
          1: 'February',
          2: 'March',
          3: 'April',
          4: 'May',
          5: 'June',
          6: 'July',
          7: 'August',
          8: 'September',
          9: 'October',
          10: 'November',
          11: 'December'
        }
        let currentMonth: MonthCalculations = null
        for (const item of calculations) {
          const calcdate = new Date(item.calculationDate)
          const month = `${
            MonthMap[calcdate.getMonth()]
          } ${calcdate.getFullYear()}`
          if (!currentMonth || currentMonth.month !== month) {
            currentMonth = {
              month,
              calculations: []
            }
            months.push(currentMonth)
          }
          currentMonth.calculations.push(item)
        }
      }
      return months
    },

    // Refresh calculations
    refreshCalculations (this: any) {
      this.$set(
        this,
        'formattedCalculations',
        this.loadCalculationsFromStore()
      )
    }
  },

  mounted (this: any) {
    const defaults = {
      breeds: [...this.$props.ibreeds],
      specifyAllowance: this.$props.ispecifyAllowance,
      paddock: {
        size: this.$props.ipaddock.size,
        growthRate: this.$props.ipaddock.growthRate,
        pastureStart: this.$props.ipaddock.pastureStart,
        pastureEnd: this.$props.ipaddock.pastureEnd,
        daysGrazing: this.$props.ipaddock.daysGrazing
      }
    }
    this.$set(this, 'specifyAllowance', defaults.specifyAllowance)
    this.$set(this, 'defaultProps', { ...defaults })
    this.$set(this, 'paddock', { ...defaults.paddock })
    this.$set(this, 'breeds', [...defaults.breeds])
    this.refreshCalculations()
    setTimeout(() => {
      try {
        window.dispatchEvent(new Event('resize')) // temp fix for the tab on page load
      } catch (e) {}
    }, 0)
  },

  components: { AnimatedNumber, Confirm },
  store
}
